export class FirestoreOperationError extends Error {
    constructor(path, cause) {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, FirestoreOperationError);
        }
        this.name = "FirestoreOperationError";
        this.firestoreCode = cause.code;
        this.message = `[${cause.code}] Firestore "${path}" failed: ${cause.message}`;
    }
}
//# sourceMappingURL=errors.js.map